/**
 * Created by Mark on 18/04/2017.
 */

import React from 'react';
import NestedComponent from './navigation-list-nest.js';
import AuthenticationStore from '../../store/authentication-store.js';

export default class NavigationMenu extends React.Component {

    constructor(props){
        super();

        this.state = {
            nodes:props.nodes || [],
            toggled:props.toggle
        };

        this.handelToggle = props.handelToggle || function (){}
    }

    componentWillReceiveProps(props){
        this.setState({nodes:props.nodes || [] , toggled:props.toggle})
    }

    hasChildren(nodeStructure , nodeID){

        for(var idx = 0 ; idx < nodeStructure.length; idx++)
        {
            var node = nodeStructure[idx];
            if (node['parent_uid'] == nodeID)
            {
                return true;
            }
        }

        return false;
    }

    constructNestedMenu(nodeStructure , parent) {
        parent = typeof parent == 'undefined' ? 0 : parent

        var response = [];
        for(var idx = 0 ; idx < nodeStructure.length; idx++)
        {

            var node = nodeStructure[idx];
            if(Number(node.uid) == 5 && !AuthenticationStore.hasCreatePermissions()) continue;
            if(Number(node.uid) == 18)
            {
                if(sessionStorage.product == "huber" || sessionStorage.getItem('product') == "hodder" ) continue;
            }

            if(Number(node.uid) == 23)
            {
                if(sessionStorage.product == "hodder" ||  sessionStorage.product == "huber" || sessionStorage.getItem('product') == "hueber" || sessionStorage.getItem('product') == "pratstart" ) continue;
            }

            if(Number(node.uid) == 20)
            {
                if(sessionStorage.product == "huber" || sessionStorage.product == "hodder") continue;
            }

            if(parent == node['parent_uid'])
            {
                response.push(<NestedComponent path={node['path']} hasChildren={this.hasChildren(nodeStructure , node['uid'])} children={this.constructNestedMenu(nodeStructure , node['uid'])} iconClassName={ node['css_class_name'] } defaultTranslation={  node['name'] } translationId={  node['translation_uid'] } />)
            }
        }

        return response;
    }

    render(){
        return (
            <ul className={(this.state.toggled === true ? " toggled" : "" ) + " main-menu"}>
                {this.constructNestedMenu(this.state.nodes , 0)}
            </ul>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/navigation-menu.js